import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { HISTORY_TYPE } from '../type/types';

interface postOrderAcceptProps {
  orderId: string;
}
// 주문 접수 승인
export const postOrderAccept = async ({ orderId }: postOrderAcceptProps) => {
  const res = await api.post<ApiResponseType<HISTORY_TYPE>>(
    '/api/web/partners/orders/accept',
    {
      orderId: orderId,
    }
  );
  return res.data;
};
